import React from "react";
import {postDataAction} from "../../../store/actions/postDataAction";
import styles from "../../../static/css/pages.module.css";
import Modal from "../../../components/modal/modal";
import {connect} from "react-redux";
import * as consts from "../../../store/constants/sendData";
import ieSvg from "../../../components/icons/ieSvg";
import axios from "axios";
import Dropdown from "../../../components/form/dropdown/dropdown";
import Button from "../../../components/form/button/button";

class RegisterUnregister extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialog: '',
      unregistrationReasons: [],
      selectedReason: null,
      isBtnSendDisabled: true
    }
  }

  componentDidMount() {
    const splitGateURL = process.env.REACT_APP_GATE.split('/');
    this.versionGate = splitGateURL[splitGateURL.length - 2].substring(1)*1;
    if (this.versionGate >= 2) {
      const fullLink = process.env.REACT_APP_GATE + 'client/unregistration/reasons';
      axios.get(fullLink).then(response => {
        const unregistrationReasons = response.data.data.unregistrationReasons.map(reason => {
          return {
            label: reason.description,
            value: reason.reasonCode
          }
        });
        this.setState({unregistrationReasons});
      }).catch(error => {
        console.log(error);
      });
    }
  }

  componentDidUpdate() {
    ieSvg()
  }

  dialogUnregister = () => {
    let dialog = this.versionGate >= 2 ? 'UNREGISTER_WITH_REASON' : 'UNREGISTER';
    this.setState({dialog})
  }

  handleClose = () => {
    this.setState({
      dialog:''
    });
    this.props.fetchData('', this, consts.CLIENT_REGISTRATION_DELETE);
    this.setState({isBtnSendDisabled: true});
  }

  changeReason = (selected) => {
    this.setState({
      isBtnSendDisabled: false,
      selectedReason: selected
    });
  }

  handleUnregister = (e) => {
    if (e.currentTarget.disabled) {
      return false;
    }
    let formData = this.versionGate >= 2 ? {reasonCode: this.state.selectedReason.value} : '';
    this.props.fetchData(process.env.REACT_APP_GATE + "client/registration/delete", this, consts.CLIENT_REGISTRATION_DELETE, formData);
  }

  renderDialog(param) {
    switch (param) {
      case "ERROR":
        if(this.props.data.items.result.errorCode === 'TAXPAYER_UNBOUND' || this.props.data.items.result.errorCode === 'TAXPAYER_UNREGISTERED') {
          this.props.fetchData('', consts.CLIENT_REGISTRATION_DELETE, null);
          window.location=process.env.PUBLIC_URL + "/page/needRegister";
          return null;
        }
        else {
        return <Modal
          class="dialog-success l-align_center"
          modalIcon="icon_error"
          viewbox="0 0 80 80"
          handleClick={this.handleClose.bind(this)}
          title="Заявление на снятие с учета не отправлено"
          body={<div className={styles.article}>{this.props.data.items.result.errorMessage}<div className={styles.article}></div></div>}
          footer="l-align_right"
          link={this.handleClose.bind(this)}
          button="Закрыть"
        />;
        }
      case "TIMEOUT":
        return  <Modal
          class="dialog-success l-align_center"
          modalIcon="icon_error"
          viewbox="0 0 80 80"
          handleClick={this.handleClose.bind(this)}
          title="Заявление на снятие с учета не отправлено"
          body={<div className={styles.article}>Сервис временно недоступен, повторите операцию позже.<div className={styles.article}></div></div>}
          footer="l-align_right"
          link={this.handleClose.bind(this)}
          button="Закрыть"
        />;
      case "SUCCESS":
        return <Modal
          class="dialog-success l-align_center"
          modalIcon="icon_success"
          viewbox="0 0 80 80"
          handleClick={this.handleClose.bind(this)}
          title="Заявление на снятие с учёта успешно отправлено"
          body={<div className={styles.article}>
            Если передумаете, вы снова можете стать самозанятым через приложение.
            <div className={styles.article}></div></div>}
          footer="l-align_right"
          link={this.handleClose.bind(this)}
          button="Закрыть"
        />;
      default:
        return null;
    }
  }

  render () {
    return (
      <div>
        Чтобы изменить свой статус самозанятого, вы можете <span className={styles.link} onClick={this.dialogUnregister}>
            Подать заявление на снятие с учёта</span>.
        <div className={styles.article}></div>
        {this.props.data.items ?
          this.renderDialog(this.props.data.items.result.status)
          :
          this.state.dialog === 'UNREGISTER' ?
            <Modal
              class="dialog-success l-align_center"
              modalIcon="icon_question"
              viewbox="0 0 80 80"
              handleClick={this.handleClose.bind(this)}
              title={<div>Отправить заявление в ФНС на снятие с учета?</div>}
              body={<div className={styles.article}>
                Заявление является подтверждением завершения вашей<br />профессиональной деятельности и оплаты налогов.
                <div className={styles.article}></div>
              </div>}
              footer="l-align_right"
              link={this.handleUnregister.bind(this)}
              button="Отправить"
            />
            :
            this.state.dialog === 'UNREGISTER_WITH_REASON' ?
            <React.Fragment>
              <Dropdown placeholder="Выберите причину" name="reason" label="Укажите причину снятия с учета"
                        items={this.state.unregistrationReasons}
                        onChange={this.changeReason} required
              />
              <div className={styles.info_block}>
                Заявление является подтверждением завершения вашей профессиональной деятельности и оплаты налогов.
              </div>
              <div className="l-align_right" style={{marginBottom: '-2.5rem'}}>
                  <Button title="Отправить" onClick={this.handleUnregister} disabled={this.state.isBtnSendDisabled}/>
              </div>
            </React.Fragment>
              :
              null
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({data: state.clientRegistrationDelete})

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, parent, types, body, el) => dispatch(postDataAction(url, parent, types, body, el))}
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterUnregister);
